import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { AuthService } from '@auth0/auth0-angular';
import { LoginRedirectService } from '@core/services/auth/login-redirect.service';
import { firstValueFrom } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class AuthGuard implements CanActivate {

  constructor(private auth: AuthService, private loginRedirect: LoginRedirectService) {}

  async canActivate(next: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<boolean> {
    const isAuthenticated = await firstValueFrom(this.auth.isAuthenticated$)
    
    if(!isAuthenticated) {
      // state.url keeps the in-app target (including its query string) in
      // appState; marketing params travel separately as ext-* authorization
      // parameters added by LoginRedirectService.
      this.loginRedirect.loginWithRedirect({ redirect: state.url });
    }

    return isAuthenticated
  }
}
